var _g, _g2, _text, _text2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_19_1",
    "data-name": "Composant 19 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 150,
    viewBox: "0 0 320 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 319.7,
    height: 149.7,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image",
    "data-name": "Icon feather-image",
    transform: "translate(181.559 36.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191",
    "data-name": "Trac\\xE9 10191",
    d: "M15.507,3H85.934A12.522,12.522,0,0,1,98.441,15.507V85.934A12.521,12.521,0,0,1,85.934,98.441H15.507A12.522,12.522,0,0,1,3,85.934V15.507A12.522,12.522,0,0,1,15.507,3ZM85.934,93.549a7.623,7.623,0,0,0,7.615-7.615V15.507a7.623,7.623,0,0,0-7.615-7.615H15.507a7.623,7.623,0,0,0-7.615,7.615V85.934a7.623,7.623,0,0,0,7.615,7.615Z",
    transform: "translate(0 0)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192",
    "data-name": "Trac\\xE9 10192",
    d: "M18.992,9A9.992,9.992,0,1,1,9,18.992,10,10,0,0,1,18.992,9Zm0,15.091a5.1,5.1,0,1,0-5.1-5.1A5.105,5.105,0,0,0,18.992,24.091Z",
    transform: "translate(14.122 14.122)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193",
    "data-name": "Trac\\xE9 10193",
    d: "M8.446,73.728a2.446,2.446,0,0,1-1.73-4.176L62.052,14.217a2.446,2.446,0,0,1,3.46,0L90.664,39.369a2.446,2.446,0,0,1-3.46,3.46L63.782,19.406,10.176,73.012A2.439,2.439,0,0,1,8.446,73.728Z",
    transform: "translate(7.061 24.713)",
    fill: "#b5b5b5"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Titre_du_bloc",
    "data-name": "Titre du bloc",
    transform: "translate(160 24)",
    fill: "#717171",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.337,
    y: 0
  }, "Titre du bloc"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Sed_ut_perspiciatis_unde_omnis_iste_natus_error_sit_voluptatem_accusantium_doloremque_laudantium_totam_rem.",
    "data-name": "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.",
    transform: "translate(23 40)",
    fill: "#717171",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Sed ut perspiciatis unde omnis "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "iste natus error sit voluptatem "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }, "accusantium doloremque "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }, "laudantium, totam rem."))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7228",
    "data-name": "Groupe 7228",
    transform: "translate(-150 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    transform: "translate(204 243)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 20,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 69.5,
    height: 19.5,
    rx: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "En_savoir_plus",
    "data-name": "En savoir plus",
    transform: "translate(239 256)",
    fill: "#717171",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.111,
    y: 0
  }, "En savoir plus")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1);
export default __webpack_public_path__ + "static/media/section1.13c313a148ccca7b7a3e519a3cc8d03c.svg";
export { ForwardRef as ReactComponent };